import script from "./ProjectCompanyDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectCompanyDetails.vue?vue&type=script&setup=true&lang=js"

import "./ProjectCompanyDetails.vue?vue&type=style&index=0&id=021fc410&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-021fc410"]])

export default __exports__